import React, { useEffect, useState } from 'react';
import AudioManager from '../audio/AudioManager';
function InstrumentSelector({ selectedInstrument, onChangeInstrument }) {
    const [instruments, setInstruments] = useState([]);
    useEffect(() => {
        const manager = AudioManager.getInstance();
        setInstruments(manager.getInstrumentNames());
    }, []);
    return (React.createElement("select", { className: "p-2 bg-gray-800 border border-gray-700 rounded text-white", value: selectedInstrument, onChange: (e) => onChangeInstrument(e.target.value) }, instruments.map((inst) => (React.createElement("option", { key: inst, value: inst }, inst)))));
}
export default InstrumentSelector;
